import { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { useParams } from "react-router-dom";
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import MenuCaracterizacion from './Componentes/MenuCaracterizacion';
import DatosCabezaFamilia from './DatosCabezaFamilia';
import { useAuth } from '../../Auth/AuthContext';

export default function Deudas(){
    const { token } = useAuth();
    const { idCabezaFamilia } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    useEffect(() => {
        const fetchData = async () => {
            const url = '/caracterizacion/crearFormulariodeudas';
            const obj = {idCabezaFamilia: idCabezaFamilia}
            try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            } catch (error) {
            console.error('Error fetching data:', error);
            } finally {
            setCargando(false);
            }
        };

        fetchData();
    }, [idCabezaFamilia, token]);
    const {register, handleSubmit } = useForm();
    const onSubmit = async (data) => {
        setCargando(true);
        const url = (data.id === 0)?'/caracterizacion/deudas/guardar':'/caracterizacion/deudas/actualizar';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar deudas', 'Registro guardado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar deudas', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar deudas', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Deudas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Deudas</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}/>
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}/>
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className='card'>
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/><input hidden {...register('id')}/>
                                
                                
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}